module.exports = __webpack_public_path__ + "img/saint-lucia.1d4f422b.svg";